import { Component, type ReactNode } from 'react';

interface AppErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

export class AppErrorBoundary extends Component<{ children: ReactNode }, AppErrorBoundaryState> {
  constructor(props: { children: ReactNode }) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: unknown) {
    console.error('[AppErrorBoundary] Error caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            /* CRITICAL: Fill viewport to prevent layout collapse and navigation bar shift */
            minHeight: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            padding: '40px 24px',
            textAlign: 'center',
            fontFamily: 'system-ui, -apple-system, sans-serif',
          }}
        >
          <div
            style={{
              maxWidth: '600px',
              margin: '0 auto',
            }}
          >
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>⚠️</div>
          <h1 style={{ color: '#dc2626', fontSize: '24px', marginBottom: '12px' }}>
            Something went wrong
          </h1>
          <p style={{ margin: '16px 0', color: '#666', fontSize: '14px' }}>
            {this.state.error?.message || 'Unknown error occurred'}
          </p>
          <details
            style={{
              background: '#f7fafc',
              padding: '16px',
              borderRadius: '8px',
              marginTop: '20px',
              textAlign: 'left',
            }}
          >
            <summary style={{ cursor: 'pointer', fontWeight: '600', marginBottom: '8px' }}>
              Error Details
            </summary>
            <pre
              style={{
                fontSize: '11px',
                overflow: 'auto',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                color: '#dc2626',
              }}
            >
              {this.state.error?.stack || 'No stack trace'}
            </pre>
          </details>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              marginTop: '24px',
              padding: '10px 24px',
              background: '#3b82f6',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '600',
            }}
          >
            Reload Page
          </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
